import { IProduct, IProductVariation } from 'interfaces/product.interface';
import { useEffect, useState } from 'react';
import useSWR from 'swr';

export default function useProduct({
  permalink = '',
  queryStringify = '',
  product = null,
  variation = null,
}: {
  permalink?: string;
  queryStringify?: string;
  product?: IProduct | null;
  variation?: IProductVariation | null;
}) {
  const [productData, setProductData] = useState<IProduct | null>(null);

  const { data, error, mutate } = useSWR<IProduct>(
    queryStringify && permalink
      ? `${process.env.NEXT_PUBLIC_API_URL}/v1/public/products/permalink/${permalink}?${queryStringify}`
      : undefined
  );

  const isLoading = !error && !data;
  const isError = error;

  useEffect(() => {
    if (data) {
      setProductData({
        ...data,
      });
    }
  }, [data]);

  useEffect(() => {
    if (product) {
      setProductData({
        ...product,
        updatedAt: new Date(),
      });
    }
  }, [product]);

  return {
    product: productData,
    isLoading,
    isError,
    mutate,
  };
}
